import COMPANIES_TO_LOAD from "../lib/companiesToLoad"
import { types } from "./rankings.actions"

const removeFilterChip = (filters, payload) => {
  const { key } = payload
  if (!key) return filters

  if (key in filters && key !== "demographicFilters") {
    return {
      ...filters,
      [key]: null
    }
  }

  if (filters.demographicFilters && key in filters.demographicFilters) {
    const { [key]: _, ...rest } = filters.demographicFilters

    return {
      ...filters,
      demographicFilters: rest
    }
  }

  return filters
}

export const initialState = {
  isCompaniesLoading: false,
  isMoreCompaniesLoading: false,
  companies: [],
  nextToken: "",

  isLoading: false,
  rankings: {
    company: []
  },
  loadFrom: 0,
  isLoadingMore: false,
  hasLoadedAll: false,
  searchTerm: "",
  whwFilters: {
    data: [],
    loading: false,
    error: null
  },
  filters: {
    award: null,
    country: null,
    industry: null,
    demographicFilters: {},
    year: null
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_COMPANIES:
      return { ...state, isCompaniesLoading: true }
    case types.LOAD_COMPANIES_SUCCESS:
      return {
        ...state,
        companies: action.payload.body,
        nextToken: action.payload.nextToken,
        isCompaniesLoading: false
      }
    case types.LOAD_COMPANIES_FAIL:
      return { ...state, isCompaniesLoading: false }
    case types.LOAD_COMPANIES_LOAD_MORE:
      return { ...state, isMoreCompaniesLoading: true }
    case types.LOAD_COMPANIES_LOAD_MORE_SUCCESS:
      return {
        ...state,
        companies: state.companies.concat(action.payload?.body || []),
        nextToken: action.payload.nextToken,
        isMoreCompaniesLoading: false
      }
    case types.LOAD_COMPANIES_LOAD_MORE_FAIL:
      return { ...state, isMoreCompaniesLoading: false }

    case types.LOAD_COMPANY_RANKINGS:
      return { ...state, isLoading: true }
    case types.LOAD_COMPANY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasLoadedAll: false,
        rankings: {
          ...state.rankings,
          company: action.payload
        },
        loadFrom: action.payload.length
      }
    case types.LOAD_FAIL:
      return { ...state, isLoading: false, isLoadingMore: false }
    case types.LOAD_MORE:
      return { ...state, isLoadingMore: true }
    case types.LOAD_MORE_SUCCESS:
      return {
        ...state,
        loadFrom: state.loadFrom + action.payload.length,
        isLoadingMore: false,
        rankings: {
          ...state.rankings,
          company: [...state.rankings.company, ...action.payload]
        },
        hasLoadedAll: action.payload.length < COMPANIES_TO_LOAD
      }

    case types.GET_SURVEY_COMPANIES:
      return { ...state, isLoadingSurveyCompanies: true }
    case types.GET_SURVEY_COMPANIES_SUCCESS:
      return {
        ...state,
        isLoadingSurveyCompanies: false,
        surveyCompanies: action.payload
      }
    case types.GET_SURVEY_COMPANIES_FAIL:
      return { ...state, isLoadingSurveyCompanies: false, surveyCompanies: [] }

    case types.APPLY_FILTERS:
      return {
        ...state,
        filters: {
          award: action.payload.award ?? state.filters.award,
          country: action.payload.country ?? state.filters.country,
          industry: action.payload.industry ?? state.filters.industry,
          demographicFilters: action.payload.demographicFilters ?? state.filters.demographicFilters,
          year: action.payload.year ?? state.filters.year
        }
      }

    case types.REMOVE_FILTER:
      return {
        ...state,
        filters: removeFilterChip(state.filters, action.payload)
      }

    case types.UPDATE_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload
      }

    case types.LOAD_WHW_FILTERS:
      return {
        ...state,
        whwFilters: {
          ...state.whwFilters,
          loading: true
        }
      }

    case types.LOAD_WHW_FILTERS_SUCCESS:
      return {
        ...state,
        whwFilters: {
          ...state.whwFilters,
          loading: false,
          data: action.payload.getFiltersMeta
        }
      }

    case types.LOAD_WHW_FILTERS_FAIL:
      return {
        ...state,
        whwFilters: {
          ...state.whwFilters,
          loading: false,
          error: action.payload
        }
      }

    default:
      return state
  }
}
